import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import { Form } from 'antd';
import * as valid from 'utils/validate';
import { KBFormError,
KBButton,
KBInput,
KBSelect } from
'components';
import { locationSettingAction, successState } from 'app/actions';
import { api } from 'app/services';
import { ENTER_RATE_CALC_TYPE, AREA_CONTRACT_ENTERING_WAO } from 'app/constants';
import * as selectors from 'app/selectors';

const getChangeValue = value => (value && value.target ? value.target.value : value);

function FormField({ children, error, onChange, onClearError, touched, value }) {
  return children({
    value,
    touched,
    error,
    onChange: nextValue => {
      onChange(getChangeValue(nextValue));
      onClearError();
    }
  });
}

function LocationSetArea({ error, locationAreaSettings, updateLocationSetting }) {
  const [form] = Form.useForm();
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const initialValues = React.useMemo(
    () => getInitialValues(locationAreaSettings),
    [locationAreaSettings]
  );
  const initialValuesKey = JSON.stringify(initialValues);

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
    setErrors({});
  }, [form, initialValuesKey]);

  const renderField = (name, render) => (
    <Form.Item name={name} noStyle>
      <FormField
        error={errors[name]}
        touched={!!errors[name]}
        onClearError={() =>
          setErrors(prevErrors => Object.assign({}, prevErrors, { [name]: undefined }))
        }
      >
        {render}
      </FormField>
    </Form.Item>
  );

  const updateLocationSettings = formValues => {
    const model = Object.assign({}, formValues);
    model.area_physical_rate = Math.floor(model.area_physical_rate * 10000) / 1000000;
    model.area_rentable_rate = Math.floor(model.area_rentable_rate * 10000) / 1000000;

    const newLocationSettings = {
      entering_rate_calc_type: model.entering_rate_calc_type,
      entering_subscription_compute_way: model.entering_subscription_compute_way
    };
    delete model.entering_rate_calc_type;
    delete model.entering_subscription_compute_way;

    return updateLocationSetting(
      {
        area_settings: model,
        location_settings: newLocationSettings
      },
      {
        key: ['area_settings', 'location_settings']
      }
    );
  };

  const handleFinish = () => {
    const formValues = form.getFieldsValue();
    const nextErrors = validate(formValues);
    if (Object.keys(nextErrors).some(name => !!nextErrors[name])) {
      setErrors(nextErrors);
      return;
    }

    setSubmitting(true);
    const result = updateLocationSettings(formValues);
    if (result && result.then) {
      return result.then(
        value => {
          setSubmitting(false);
          return value;
        },
        requestError => {
          setSubmitting(false);
          throw requestError;
        }
      );
    }
    setSubmitting(false);
    return result;
  };

  return (
    <div className="nav-section-content-container" style={{ padding: 0 }}>
      <header className="nav-header">
        <div className="nav-section-header-title">
          <span>工位设置</span>
        </div>
      </header>
      <div className="kb-form-container">
        <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
          <KBFormError error={error} />
          <div className="kb-form-container" style={{ padding: '0 400px 0 0' }}>
            <div className="kb-row">
              {renderField('m2_per_desk', field => (
                <KBInput
                  className="kb-form-group kb-div-c48 kb-form-alone"
                  title="平方米/工位"
                  field={field}

                />
              ))}
            </div>
            <div className="kb-row">
              {renderField('house_fee_per_m2', field => (
                <KBInput
                  className="kb-form-group kb-div-c48 kb-form-alone"
                  title="月物业费面积单价"
                  field={field}

                />
              ))}
            </div>
            <div className="kb-row">
              {renderField('entering_rate_calc_type', field => (
                <KBSelect
                  className="kb-form-group kb-div-c48 kb-form-alone"
                  field={field}

                  title="入驻率计算方式"
                  arrayData={ENTER_RATE_CALC_TYPE}
                />
              ))}
            </div>
            <Form.Item noStyle shouldUpdate={(prev, next) => prev.entering_rate_calc_type !== next.entering_rate_calc_type}>
              {({ getFieldValue }) =>
                getFieldValue('entering_rate_calc_type') === 'by_scale' ? (
                  <div className="kb-row">
                    {renderField('area_physical_rate', field => (
                      <KBInput
                        className="kb-form-group kb-div-c48 kb-form-alone"
                        title="总物理面积比率"
                        field={field}

                        inputClass="input-percent"
                        hint="使用率"
                        type="number"
                      />
                    ))}
                  </div>
                ) : null
              }
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prev, next) => prev.entering_rate_calc_type !== next.entering_rate_calc_type}>
              {({ getFieldValue }) =>
                getFieldValue('entering_rate_calc_type') === 'by_scale' ? (
                  <div className="kb-row">
                    {renderField('area_rentable_rate', field => (
                      <KBInput
                        className="kb-form-group kb-div-c48 kb-form-alone"
                        title="可出租面积比率"
                        field={field}

                        inputClass="input-percent"
                        hint="签约得房率"
                        type="number"
                      />
                    ))}
                  </div>
                ) : null
              }
            </Form.Item>
            <div className="kb-row">
              {renderField('entering_subscription_compute_way', field => (
                <KBSelect
                  className="kb-form-group kb-div-c48 kb-form-alone"
                  field={field}

                  title="合同入驻计算方式"
                  arrayData={AREA_CONTRACT_ENTERING_WAO}
                />
              ))}
            </div>
            <div className="kb-row m-top">
              <KBButton className="certain-btn" type="submit" submitting={submitting}>
                保存
              </KBButton>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}

function mapStateToProps(state, props) {
  const loc_id = props.params.id;
  const locationSetting = selectors.getLocationSetting(state, loc_id) || {};
  const areaSettings = locationSetting.area_settings || {};
  const locationSettings = locationSetting.location_settings || {};

  return {
    loc_id,
    locationAreaSettings: Object.assign({}, areaSettings, locationSettings)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    locationSettingActions: bindActionCreators(locationSettingAction.update, dispatch),
    successAction: bindActionCreators(successState, dispatch)
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const updateLocationSetting =
    typeof ownProps.updateLocationSetting === 'function'
      ? ownProps.updateLocationSetting
      : (model, { key }) => {
          const { loc_id } = stateProps;
          const { locationSettingActions, successAction } = dispatchProps;
          return api
            .putSpaceSetting({
              target_type: 'Location',
              target_id: loc_id,
              settings: model
            })
            .then(
              json => {
                locationSettingActions.success(json, { location_id: loc_id, key });
                successAction({ message: '保存成功!' });
              },
              requestError => {
                locationSettingActions.failure(requestError);
              }
            );
        };

  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    updateLocationSetting
  });
}

const validate = values => {
  const errors = {};

  if (valid.Float(values.m2_per_desk) || values.m2_per_desk < 0) {
    errors.m2_per_desk = '请输入正确格式';
  }

  if (valid.Float(values.house_fee_per_m2) || values.house_fee_per_m2 < 0) {
    errors.house_fee_per_m2 = '请输入正确格式';
  }

  return errors;
};

const getInitialValues = (setting = {}) => ({
  m2_per_desk: (setting && setting.m2_per_desk) || 0,
  house_fee_per_m2: (setting && setting.house_fee_per_m2) || 0,
  area_physical_rate:
    Math.floor(parseFloat((setting && setting.area_physical_rate) || 0) * 1000000) / 10000,
  area_rentable_rate:
    Math.floor(parseFloat((setting && setting.area_rentable_rate) || 0) * 1000000) / 10000,
  entering_rate_calc_type: setting && setting.entering_rate_calc_type,
  entering_subscription_compute_way: setting && setting.entering_subscription_compute_way
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(LocationSetArea);
